import { ApiClient } from "../../account/models/ApiClient";
import { jwtAuthAxios } from "../../shared/utils/network-utils";

export const SuperAdminApi = {

  getAdminAccountApiClients: async () => {
    return await jwtAuthAxios().get<ApiClient[]>(`/admin/api-clients`);
  },

};
